import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";
import { logoutAction } from "redux/actions/authActions";
import store from "redux/store";

const appAxios = axios.create({
  baseURL: process.env.REACT_APP_API_ADDRESS ? process.env.REACT_APP_API_ADDRESS + '/api' : '/api',
});

appAxios.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    const { auth } = store.getState();
    if (auth.token) {
      config.headers["Authorization"] = "Bearer " + auth.token;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
/**
 * For handling 401: Unauthorization
 */
appAxios.interceptors.response.use(
  function (response) {
    if (response.status === 201) {
      toast.success("Изменения сохранены!");
    }
    return response;
  },
  function (error) {
    // Отменённый запрос (AbortController) — не показываем ошибок
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    console.log("error.response.status: ", error);
    // Демо-доступ закончился — ведём на страницу тарифов (без всплывающих ошибок на каждый запрос)
    if (error.response?.status === 402 && error.response?.data?.error?.code === "TRIAL_EXPIRED") {
      if (!window.location.pathname.startsWith("/admin/plans")) {
        window.location.href = "/admin/plans?trial=expired";
      }
      return Promise.reject(new Error(error.response.data.error.message));
    }
    if (error.response.status === 401 || error.response.status === 403) {
      console.log("error.response: ", error.response.data.error);
      const message = error.response?.data?.error?.message
      toast.error(message);
      // store.dispatch(logoutAction());
      // localStorage.removeItem('orgID')
      // setTimeout(() => {
      //   // window.location = "/";
      // }, 2000);
      return Promise.reject(new Error(message));
    } else if (error.response.status === 201) {
      toast.success("Изменения сохранены!");
    } else {
      console.error("http ex: ", error);
      if (error instanceof AxiosError) {
        console.log(`${error.request?.responseURL} Response error:`, error);
        // alert(error.response.data?.error?.message);
        toast.error(error.response.data?.error?.message)
      } else {
        toast.error('Серверная ошибка. Попробуйте позже');
      }
      return Promise.reject(error);
    }
  }
);

export default appAxios;
